import gql from 'graphql-tag'
export default gql`
  mutation createToken($username: String, $password: String, $id_token: String) {
    createToken(username: $username, password: $password, id_token: $id_token)
  }
`
